import React from "react";
import classNames from "classnames";

import { nucleus } from "../NucleusTheme";
import styles from "./threeBounce.module.css";

const DEFAULT_SIZE = 15;

export const ThreeBounce = ({
    color = nucleus.primary,
    size = DEFAULT_SIZE,
    ...rest
}: ThreeBounceProps) => {
    const containerStyle = {
        "--circle-color": color,
        "--circle-size": `${size}px`
    } as React.CSSProperties;

    return (
        <span {...rest} style={containerStyle}>
            <div className={classNames(styles.circle, styles.circleOne)} />
            <div className={classNames(styles.circle, styles.circleTwo)} />
            <div className={classNames(styles.circle, styles.circleThree)} />
        </span>
    );
};

type ThreeBounceProps = {
    color?: string;
    size?: number;
} & React.HTMLAttributes<HTMLSpanElement>;
